import React, { ReactElement } from 'react';
import type { Route } from 'next';
import classNames from 'classnames/bind';
import Link from 'next/link';
import { servicesData } from 'sections/Services/data';
import { ServiceType } from 'sections/Services/types';
import Card from 'components/Card';
import styles from 'sections/Services/components/SectionCards/SectionCards.module.scss';

const cn = classNames.bind(styles);

const SectionCards = (): ReactElement => {
  const cards = servicesData.map((item: ServiceType) => {
    return (
      <Card className={cn('card')} key={item.id}>
        <div className={cn('card__content')}>
          <Card.Header className={cn('card__title-box')}>
            <div className={cn('card__icon')}>
              <img
                src={`/images/pages/Services/${item.iconName}.svg`}
                alt={item.alt}
              />
            </div>
            <h3 className={cn('card__title')}>{item.heading}</h3>
          </Card.Header>
          <Card.Content className={cn('card__description')}>
            <p>{item.description}</p>
          </Card.Content>
        </div>
        {item.url
          ?
          <Card.Footer className={cn('card__buttons')}>
            <Link className={cn('card__button-learn')} href={item.url as Route}>
              Learn more
              <svg viewBox="0 0 10 10" aria-hidden="true">
                <path d="M1 5h7" />
                <path d="M2 1l4 4-4 4" />
              </svg>
            </Link>
          </Card.Footer>
          :
          null
        }
      </Card>
    );
  });

  return (
    <section className={cn('cards')}>
      <div className={cn('container')}>
        <div className={cn('cards__list')}>
          {cards}
        </div>
      </div>
    </section>
  );
};

export default SectionCards;